package com.example.mystybag.appCore.logic

import com.example.mystybag.appCore.logic.CitySelectionBottomSheetChild
import com.example.mystybag.appCore.logic.NavigatorDeleteAccountRequest
import com.example.mystybag.appCore.logic.CitySelectionBottomSheetViewModel
import com.example.mystybag.appCore.logic.NavigatorSelectPage
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_DELIVERY
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_FAVORITES
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_HOME
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_PROFILE
import com.example.mystybag.appCore.logic.PhoneSelectionBottomSheetChild
import com.example.mystybag.appCore.logic.PhoneSelectionBottomSheetViewModel
import com.example.mystybag.appCore.model.PersonalDetailsUIState
import com.example.mystybag.common.logic.BSNavigatorChooseTakePhotoOrPickFile
import com.example.mystybag.common.logic.BSNavigatorDualTextInput
import com.example.mystybag.common.logic.BSNavigatorTextInput
import com.example.mystybag.common.logic.ChooseTakePhotoOrPickFileBottomSheetChild
import com.example.mystybag.common.logic.BSNavigatorCitySelection
import com.example.mystybag.common.logic.BSNavigatorPhoneInput
import com.example.mystybag.common.logic.DualTextInputBottomSheetChild
import com.example.mystybag.common.logic.DualTextInputBottomSheetViewModel
import com.example.mystybag.common.logic.TextInputBottomSheetChild
import com.example.mystybag.common.logic.TextInputBottomSheetViewModel
import com.example.mystybag.common.model.ChooseTakePhotoOrPickFileVisualModel
import com.example.mystybag.common.model.DualTextInputBSVisualModel
import com.example.mystybag.common.model.TextInputBSVisualModel
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.defines.TextFieldType
import com.example.mystybag.core.extensions.formatNames
import com.example.mystybag.core.extensions.isValidEmail
import com.example.mystybag.core.extensions.isValidPhone
import androidx.compose.ui.text.input.KeyboardType
import com.example.mystybag.communication.Communication
import com.example.mystybag.communication.defines.FileUploadTarget
import com.example.mystybag.communication.ext.CommandResult
import com.example.mystybag.communication.common.CommonCommands
import com.example.mystybag.communication.utils.onResponse
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_CITY
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_CITY_ID
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_EMAIL
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_FIRST_NAME
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_LAST_NAME
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_PHOTO_GUID
import com.example.mystybag.core.expected.PlatformHelperWrapper.openGallery
import com.example.mystybag.core.expected.PlatformHelperWrapper.takePhoto
import com.example.mystybag.core.expected.Preferences.getLong
import com.example.mystybag.core.expected.Preferences.getSecureString
import com.example.mystybag.core.expected.LogHelper
import com.example.mystybag.core.expected.Preferences.setLong
import com.example.mystybag.core.expected.Preferences.setSecureString as setPrefSecureString
import com.example.mystybag.core.expected.Preferences.setString as setPrefString
import com.example.mystybag.core.expected.byteArrayFromFile
import com.example.mystybag.core.expected.openSettings
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.extensions.separate
import com.example.mystybag.core.helpers.GlobalCommonData
import com.example.mystybag.core.helpers.GlobalCommonData.getEmailValue
import com.example.mystybag.core.helpers.GlobalCommonData.setEmailValue
import com.example.mystybag.core.helpers.GlobalCommonData.getFirstNameValue
import com.example.mystybag.core.helpers.GlobalCommonData.getLastNameValue
import com.example.mystybag.core.helpers.GlobalCommonData.getDialCodeValue
import com.example.mystybag.core.helpers.GlobalCommonData.getPhoneNumberValue
import com.example.mystybag.core.helpers.GlobalCommonData.setDialCodeValue
import com.example.mystybag.core.helpers.GlobalCommonData.setPhoneNumberValue
import com.example.mystybag.core.helpers.GlobalCommonData.setFirstNameValue
import com.example.mystybag.core.helpers.GlobalCommonData.setLastNameValue
import com.example.mystybag.common.logic.DialogNavigatorStandard
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.BottomSheetChild
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.logic.base.MainCallback
import com.example.mystybag.core.logic.base.UIBottomSheetConfig
import com.example.mystybag.login.logic.NavigatorFeatureLoginAndRegistration
import com.example.mystybag.logoutUtils.helpers.LogoutMethods.deleteAppDataAndGoToEntryScreen
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.cropImage.logic.NavigatorProfileCropImage
import com.example.mystybag.cropImage.logic.ProfileImageCropperCallbacks
import com.example.mystybag.permissionsUtils.expected.Permission
import com.example.mystybag.permissionsUtils.expected.PermissionHelper.requestPermission
import com.example.mystybag.permissionsUtils.logic.DialogNavigatorPermissionSettings
import com.example.mystybag.sharedmodels.SCImage
import com.example.mystybag.sharedmodels.mystyBag.requestModels.GenerateEmailVerificationCodeRequestModel
import com.example.mystybag.sharedmodels.mystyBag.requestModels.UpdateProfileImageRequestModel
import com.example.mystybag.sharedmodels.mystyBag.requestModels.UpdateUserProfileRequestModel
import kotlinx.coroutines.launch

class PersonalDetailsViewModel(context: AppContext): ChildViewModel<PersonalDetailsUIState>(context, PersonalDetailsUIState()) {
    private var oldEmail        = getEmailValue()
    private var newEmail        = ""
    private var pendingNewEmail = ""

    override fun onCreate() {
        navControls.title = sharedString(SR.strings.profile)
        getUserData()
    }

    override fun onResume() {
        getEmailValue().let { emailData ->
            if (emailData != newEmail) {
                newEmail = emailData
                updateState { it.copy(email = newEmail) }
            }
        }
    }

    override fun configureBottomSheets(config: UIBottomSheetConfig, context: AppContext): BottomSheetChild = when (config) {
        is BSNavigatorChooseTakePhotoOrPickFile -> ChooseTakePhotoOrPickFileBottomSheetChild(
            title               = sharedString(SR.strings.profile_photo),
            infoText            = listOf(),
            onInfoButtonClicked = { },
            additionalRows = arrayListOf(
                ChooseTakePhotoOrPickFileVisualModel(
                    text    = sharedString(SR.strings.take_photo),
                    image   = SRC.images.camera_fill_icon,
                    onClick = {
                        closeBottomSheet {
                            launchOnMain {
                                onCameraPermissionResponse(requestPermission(Permission.CaptureImage))
                            }
                        }
                    }
                ),
                ChooseTakePhotoOrPickFileVisualModel(
                    text    = sharedString(SR.strings.open_gallery),
                    image   = SRC.images.gallery_fill_icon,
                    onClick = {
                        closeBottomSheet {
                            launchOnMain { onGalleryPermissionResponse(requestPermission(Permission.OpenGallery)) }
                        }
                    }
                )
            )
        )
        is BSNavigatorTextInput -> TextInputBottomSheetChild(viewModel = TextInputBottomSheetViewModel(context, config.visualModel))
        is BSNavigatorDualTextInput -> DualTextInputBottomSheetChild(viewModel = DualTextInputBottomSheetViewModel(context, config.visualModel))
        is BSNavigatorCitySelection -> CitySelectionBottomSheetChild(viewModel = CitySelectionBottomSheetViewModel(context, config))
        is BSNavigatorPhoneInput -> PhoneSelectionBottomSheetChild(viewModel = PhoneSelectionBottomSheetViewModel(context, config))
        else                                    -> super.configureBottomSheets(config, context)
    }

    override fun parentCloseBottomSheet() {
        LogHelper.logEvent("[WebDialogCloseButton] PersonalDetailsViewModel closeBottomSheet requested")
        closeBottomSheet()
    }

    fun onAvatarImageButtonClicked() {
        openBottomSheet(BSNavigatorChooseTakePhotoOrPickFile)
    }

    fun onEmailRowClick() {
        openBottomSheet(
            BSNavigatorTextInput(
                TextInputBSVisualModel(
                    initialText     = uiState.value.email,
                    title           = sharedString(SR.strings.email),
                    hint            = sharedString(SR.strings.email_address),
                    buttonText      = sharedString(SR.strings.save),
                    inputType       = TextFieldType.EMAIL,
                    keyboardType    = KeyboardType.Email,
                    infoPromptText  = sharedString(SR.strings.change_email_verification_info),
                    validate        = { email ->
                        when {
                            email.isBlank() -> Pair(false, sharedString(SR.strings.please_enter_valid_email_address))
                            !email.isValidEmail -> Pair(false, sharedString(SR.strings.please_enter_valid_email_address))
                            else -> Pair(true, null)
                        }
                    },
                    onTextChanged   = { onEmailChanged(it) }
                )
            )
        )
    }
    fun onPhoneRowClick() {
        openBottomSheet(
            BSNavigatorPhoneInput(
                initialDialCode = getDialCodeValue(),
                initialPhoneNumber = getPhoneNumberValue(),
                onPhoneSelected = { dialCode, phoneNumber -> onPhoneChanged(dialCode, phoneNumber) }
            )
        )
    }
    fun onNameRowClick() {
        openBottomSheet(
            BSNavigatorDualTextInput(
                DualTextInputBSVisualModel(
                    initialText1   = getFirstNameValue(),
                    initialText2   = getLastNameValue(),
                    title          = sharedString(SR.strings.your_name),
                    hint1          = sharedString(SR.strings.first_name_label),
                    hint2          = sharedString(SR.strings.last_name_label),
                    buttonText     = sharedString(SR.strings.save),
                    validate       = { first, last ->
                        when {
                            first.isBlank() || last.isBlank() -> Pair(false, sharedString(SR.strings.name_required))
                            else -> Pair(true, null)
                        }
                    },
                    onTextChanged  = { first, last -> onNameChanged(first, last) }
                )
            )
        )
    }
    fun onCityRowClick() {
        openBottomSheet(
            BSNavigatorCitySelection(
                initialCityName = uiState.value.city,
                onCitySelected = { cityId, cityName -> onCityChanged(cityId, cityName) }
            )
        )
    }
    fun onDeleteAccountClick() {
        navigate(NavigatorDeleteAccountRequest)
    }

    fun onBackClick() {
        goBack()
    }

    fun onLogOutClick() {
        scope.launch {
            showDialog(
                DialogNavigatorStandard(
                    title = sharedString(SR.strings.log_out),
                    message = sharedString(SR.strings.are_you_sure_you_want_to_proceed),
                    positiveTitle = sharedString(SR.strings.log_out_yes),
                    negativeTitle = sharedString(SR.strings.cancel),
                    stackedButtons = true
                )
            ).onPositiveClick {
                deleteAppDataAndGoToEntryScreen("")
                scope.launch {
                    setResult<MainCallback> {
                        popToMainAndNavigate(NavigatorFeatureLoginAndRegistration())
                    }
                }
            }
        }
    }

    private fun getUserData() {
        val firstName   = getSecureString(PREFERENCES_FIRST_NAME, "")
        val lastName    = getSecureString(PREFERENCES_LAST_NAME, "")

        updateState {
            it.copy(
                userName                = firstName.separate(lastName),
                email                   = oldEmail.ifEmpty { getSecureString(PREFERENCES_EMAIL, "") },
                dialCode                = getDialCodeValue(),
                phoneNumber             = getPhoneNumberValue(),
                city                    = getSecureString(PREFERENCES_CITY, "")
            )
        }
    }

    private fun onContactUsClicked() {

    }

    private fun onEmailChanged(email: String) {
        pendingNewEmail = email
        closeBottomSheet()
        commandBlock(showProgress = true) {
            CommonCommands.sendGenerateEmailVerificationCode(
                GenerateEmailVerificationCodeRequestModel(
                    userId = GlobalCommonData.userId,
                    newEmail = email
                )
            ).onResponse(
                success = {
                    launchOnMain {
                        openBottomSheet(
                            BSNavigatorTextInput(
                                TextInputBSVisualModel(
                                    initialText   = "",
                                    title         = sharedString(SR.strings.verification_code_title),
                                    hint          = sharedString(SR.strings.enter_verification_code),
                                    buttonText    = sharedString(SR.strings.save),
                                    inputType     = TextFieldType.ANY,
                                    keyboardType  = KeyboardType.Number,
                                    infoPromptText = sharedString(SR.strings.verification_code_email_sent_description),
                                    validate      = { code ->
                                        if (code.isBlank()) Pair(false, sharedString(SR.strings.enter_verification_code))
                                        else Pair(true, null)
                                    },
                                    onTextChanged = { code -> onEmailVerificationCodeSubmitted(code) }
                                )
                            )
                        )
                    }
                },
                baseError = { response ->
                    launchOnMain {
                        showSnackbar(com.example.mystybag.communication.utils.Response.getErrorMessage(response.status, response.apiEndPoint, response.statusMessage))
                    }
                }
            )
        }
    }

    private fun onEmailVerificationCodeSubmitted(code: String) {
        closeBottomSheet()
        val cityId = getLong(PREFERENCES_CITY_ID, 0L)
        commandBlock(showProgress = true) {
            CommonCommands.sendUpdateUserProfile(
                UpdateUserProfileRequestModel(
                    userId = GlobalCommonData.userId,
                    firstName = getFirstNameValue(),
                    lastName = getLastNameValue(),
                    email = pendingNewEmail,
                    dialCode = getDialCodeValue(),
                    phoneNumber = getPhoneNumberValue(),
                    cityId = cityId,
                    verificationCode = code
                )
            ).onResponse(
                success = {
                    launchOnMain {
                        newEmail = pendingNewEmail
                        setPrefString(PREFERENCES_EMAIL, pendingNewEmail)
                        setEmailValue(pendingNewEmail)
                        updateState { it.copy(email = pendingNewEmail) }
                        pendingNewEmail = ""
                        showSnackbar(SR.strings.save)
                    }
                },
                baseError = { response ->
                    launchOnMain {
                        showSnackbar(com.example.mystybag.communication.utils.Response.getErrorMessage(response.status, response.apiEndPoint, response.statusMessage))
                    }
                }
            )
        }
    }

    private fun onPhoneChanged(dialCode: String, phoneNumber: String) {
        setDialCodeValue(dialCode)
        setPhoneNumberValue(phoneNumber)
        updateState { it.copy(dialCode = dialCode, phoneNumber = phoneNumber) }
        closeBottomSheet()
        sendUpdateUserProfileToServer()
    }

    private fun onNameChanged(first: String, last: String) {
        setFirstNameValue(first)
        setLastNameValue(last)
        updateState { it.copy(userName = first.separate(last).formatNames()) }
        closeBottomSheet()
        sendUpdateUserProfileToServer()
    }

    private fun onCityChanged(cityId: Long, cityName: String) {
        setLong(PREFERENCES_CITY_ID, cityId)
        setPrefSecureString(PREFERENCES_CITY, cityName)
        updateState { it.copy(city = cityName) }
        closeBottomSheet()
        sendUpdateUserProfileToServer()
    }

    private fun sendUpdateUserProfileToServer() {
        val cityId = getLong(PREFERENCES_CITY_ID, 0L)
        commandBlock(showProgress = false) {
            CommonCommands.sendUpdateUserProfile(
                UpdateUserProfileRequestModel(
                    userId = GlobalCommonData.userId,
                    firstName = getFirstNameValue(),
                    lastName = getLastNameValue(),
                    email = getEmailValue(),
                    dialCode = getDialCodeValue(),
                    phoneNumber = getPhoneNumberValue(),
                    cityId = cityId
                )
            ).onResponse(
                success = { },
                baseError = { response ->
                    launchOnMain {
                        showSnackbar(com.example.mystybag.communication.utils.Response.getErrorMessage(response.status, response.apiEndPoint, response.statusMessage))
                    }
                }
            )
        }
    }

    private fun onGalleryPermissionResponse(isGranted: Boolean) {
        if (isGranted)
            launchOnMain { openGallery()?.image?.let { image -> cropImage(image) } }
        else
            showPermissionDialog(false)
    }

    private fun onCameraPermissionResponse(isGranted: Boolean) {
        if (isGranted)
            launchOnMain { takePhoto()?.image?.let { cropImage(it) } }
        else
            showPermissionDialog(true)
    }

    private fun cropImage(image: SCImage) {
        navigate(NavigatorProfileCropImage(image, object: ProfileImageCropperCallbacks {
            override fun onImageCropped(imageFileName: String, originalImgFileName: String) {
                goBack()
                showProgress(true)
                scope.launch {
                    val byteArray = byteArrayFromFile(imageFileName)
                    if (byteArray == null) {
                        showProgress(false)
                        showSnackbar(SR.strings.an_error_occurred_please_try_again_later)
                        return@launch
                    }
                    val uploadResult = Communication.uploadFile(
                        target = FileUploadTarget.PROFILE,
                        fileData = byteArray,
                        fileName = "photo.jpg"
                    )
                    when (uploadResult) {
                        is CommandResult.Success -> sendUpdateProfileImageCommand(uploadResult.successModel.url)
                        else -> {
                            showProgress(false)
                            showSnackbar(SR.strings.an_error_occurred_please_try_again_later)
                        }
                    }
                }
            }
        }))
    }

    private fun sendUpdateProfileImageCommand(profileImageUrl: String) {
        commandBlock(showProgress = true) {
            CommonCommands.sendUpdateProfileImage(UpdateProfileImageRequestModel(profileImageUrl = profileImageUrl))
                .onResponse(
                    success = {
                        setPrefString(PREFERENCES_PHOTO_GUID, profileImageUrl)
                        launchOnMain {
                            updateState {
                                it.copy(userImage = uiState.value.userImage.copy(link = profileImageUrl))
                            }
                            showProgress(false)
                            closeBottomSheet()
                        }
                    },
                    baseError = {
                        launchOnMain {
                            showProgress(false)
                            showSnackbar(SR.strings.an_error_occurred_please_try_again_later)
                        }
                    }
                )
        }
    }

    private fun showPermissionDialog(isForCamera: Boolean) {
        uiThread {
            showDialog(
                DialogNavigatorPermissionSettings(
                    sharedString(
                        if (isForCamera)
                            SR.strings.camera_permission
                        else
                            SR.strings.gallery_permission
                    )
                )
            )
            .onPositiveClick {
                openSettings()
            }
        }
    }
}